export default "<app-toasts aria-live=\"polite\" aria-atomic=\"true\"></app-toasts>\r\n<router-outlet></router-outlet>";